import { BrowserModule } from '@angular/platform-browser';
import { inject, NgModule, provideAppInitializer } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BootService } from './services/boot/boot.service';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ApiModule } from './services/api/api.module';
import { AuthInterceptor } from './services/auth/interceptors/auth.interceptor';
import { CommonModule } from '@angular/common';
import { WINDOW_PROVIDERS } from './utils/window-utils';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { RouterModule } from '@angular/router';
import { ErrorModalComponent } from './common/components/modals/error-modal/error-modal.component';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    RouterModule,
    ApiModule,
    ScrollingModule,
    ErrorModalComponent,
  ],
  providers: [
    BootService,
    WINDOW_PROVIDERS,
    provideAppInitializer(() => {
      const initializerFn = (
        (boot: BootService) => () =>
          boot.init()
      )(inject(BootService));
      return initializerFn();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppComponentModule {}
